import { PAYMENT_MODES } from "constants/paymentModes";
import { getPaymentAlert } from "../../../../../logics/src/utils/getPaymentAlert";
import { getStringFromId } from "helpers/vernacular";
import { VERNACULAR_DEFAULT_MESSAGES, VERNACULAR_STRING_IDS } from "constants/vernacularConstants";
import { IOfferMessage, OfferDataInterface, VpaConfig } from "../@types/savedMethods";
import { getVpaDetails } from "layouts/Payment/common/dependencies/dependencyhelpers";
import { ALERT_PAYMENT_STATUS, PAYMENT_ALERT_MESSAGE } from "../../constants";
import { getOfferMessages } from "../../../../../logics/src/utils/helpers";
import { doCheckOffers } from "../../../../../logics/src/utils/checkOffers";
import { getIcons, ICONS_NAMES } from "helpers/utils/getIcons";
import { getPlatform } from "../../../../../helpers/index";
import { BUTTON_TYPE } from "constants/index";
import { ALERT_PAYMENT_MODE_VALUE } from "constants/alert";
import { UPI_METHODS } from "constants/payment";
import { formatNumber } from "helpers/utils/numberFormatter";

export const getSavedUpiMethodContextData = ({
  paymentContext,
  timerCallback,
  setUpiDetails,
  orderAmount: grandTotal,
  doPayment,
  toggleOfferBottomSheet,
  isLastPayment,
  strikedPaymentText,
  isApp,
  theme,
}: any) => {
  const platform = getPlatform();
  const cartRules = paymentContext?.offersData;
  const paymentInfo = paymentContext?.paymentInfo;
  const setLoading = paymentContext?.setLoading;
  const setIsPaymentProcessing = paymentContext?.setIsPaymentProcessing;
  const upiMapping = paymentInfo?.upiMapping;
  let vpaList = paymentInfo?.customerVpaList;
  const lastUpiPayment = paymentInfo?.lastPaymentInfo?.paymentInfo;
  const paymentAlertInfo = paymentInfo?.paymentAlertInfo;
  const alertConfig = getPaymentAlert(paymentAlertInfo, PAYMENT_MODES.UPI, paymentInfo);
  const isPaymentEnabled = alertConfig?.isPaymentEnabled;
  const lessPriority = alertConfig?.lessPriority;
  const isPaymentMethodVisible = alertConfig?.isPaymentMethodVisible;
  let warningMessage = alertConfig?.alertMessage;
  const upiPaymentAlertInfo = paymentInfo?.paymentAlertInfo?.[PAYMENT_MODES.UPI];
  const upiIntentList = paymentContext?.upiIntentList;

  const installedPSP = upiIntentList?.map((intent: any) => intent?.title);
  const upiIntentDetails = upiMapping.find((upi: any) => upi?.package === paymentInfo?.lastPaymentInfo?.packageName);

  const saveUpiConfig: any = [];
  let offerDetailConfig: any = {};

  const title = getStringFromId(VERNACULAR_STRING_IDS.UPI, VERNACULAR_DEFAULT_MESSAGES.UPI);

  const payNowText = getStringFromId(VERNACULAR_STRING_IDS.DYNAMIC_PAY, `Pay ₹${formatNumber(grandTotal)}`, {
    count: grandTotal,
  });

  const handleSavedUpiSubmit = (vpa: string, offerData: OfferDataInterface, value: VpaConfig): void | boolean => {
    const enableIntent = value?.enableIntent;
    if (isPaymentEnabled) {
      const vpaDetails: {
        title: string;
        vpa: string;
        icon: string;
        notifyIcon: string;
        completeIcon: string;
        message: string;
        showSavedVpa: boolean;
        amountToPay?: number;
      } = getVpaDetails(vpa, upiMapping);
      const upiApp = vpaDetails.title ? UPI_METHODS[vpaDetails.title] : '';
      let amountToPay = grandTotal;
      if (offerData?.hasOffers) {
        amountToPay = offerData?.finalOrderAmount as number;
      }
      vpaDetails.amountToPay = amountToPay;
      setUpiDetails(vpaDetails);
      setIsPaymentProcessing(true);
    
      let upiPaymentInfo;
      if (vpa?.length === 10) {
        upiPaymentInfo = "gpay";
      }
      if (enableIntent) {
        doPayment(PAYMENT_MODES.INTENT, {
          packageName: value?.packageName,
          isSavedUpi: true,
          timerCallback,
          offerData,
          grandTotal,
          isSaved:true,
          intentApp: upiApp,
        });
      } else {
        doPayment(PAYMENT_MODES.UPI, {
          vpa,
          isSavedUpi: true,
          timerCallback,
          upiPaymentInfo,
          mode: PAYMENT_MODES.UPI,
          paymentMethodTracking: PAYMENT_MODES.UPI,
          offerData,
          // Required for adding Money to wallet and giftcard purchase
          grandTotal,
          isSaved:true,
          intentApp: upiApp,
        });
      }

    } else {
      //No need of this statement;
      return false;
    }
  };

  /**
   * function to check all upi methods having issue
   */
  const allUpisHavingIssues = () => {
    let allHavingIssues = false;
    const bankName = upiPaymentAlertInfo?.bankName;
    if (Array.isArray(bankName) && bankName?.includes(ALERT_PAYMENT_MODE_VALUE.UPI)) {
      allHavingIssues = true;
    }
    return allHavingIssues;
  };

  const vpaHandleList: VpaConfig[] = [];

  /**
   * in webview, if UPI PSP App installed in user's device
   * then Show as one UPI Intent o/w show as upi collect.
   */
  vpaList.forEach((vpa: VpaConfig) => {
    const isVpaPresent = vpaHandleList?.some((list: any) => list?.title === vpa.title);
    if (!isVpaPresent && installedPSP.includes(vpa.title)) {
      vpa.enableIntent = true;
      vpaHandleList.push(vpa);
    }
    if (!installedPSP.includes(vpa.title)) {
      vpa.enableIntent = false;
      vpaHandleList.push(vpa);
    }
  })

  // last used payment method case
  if (isLastPayment && lastUpiPayment) {
    const vpaDetails = getVpaDetails(lastUpiPayment, upiMapping);
    const vpa = vpaDetails?.vpa;

    let offerMessages: IOfferMessage[] = [];
    let revisedBtnText = strikedPaymentText;
    let offerData = {} as OfferDataInterface;
    let offers: any[] = [];
    let enableIntent;
    if (
      upiPaymentAlertInfo?.mode === PAYMENT_MODES.UPI &&
      (upiPaymentAlertInfo?.status === ALERT_PAYMENT_STATUS.NORMAL ||
        (upiPaymentAlertInfo?.status === ALERT_PAYMENT_STATUS.WARNING))
    ) {
      warningMessage = "";
      if (allUpisHavingIssues() || (upiPaymentAlertInfo?.bankName?.length && upiPaymentAlertInfo?.bankName?.includes(vpaDetails?.title))) {
        warningMessage = alertConfig?.alertMessage;
      } 
    }
    if (Array.isArray(vpaHandleList) && vpaHandleList.length) {
      const vpaHandle = vpaHandleList.filter(list => list.vpa === vpa);
      const vpaInfo = vpaHandle?.[0];
      const offerKeys = paymentInfo?.lastPaymentInfo?.offerKeys || [];
      // it is for webview
      enableIntent = vpaHandle.length ? vpaInfo?.enableIntent : false;
      // incase of app is installed and collect is last payment method then show as a intent.
      if (!enableIntent && installedPSP?.includes(vpaDetails?.title)) {
        enableIntent = true;
      }
      if (offerKeys?.length) {
        offerKeys.forEach((offerKey: string) => {
          let offer = cartRules.paymentRules.filter(
            (rule: PaymentOfferRule) => rule.ruleKey === offerKey
          );
          offers.push(offer);
          offers = offers.flat();
        });
        if (offers?.length > 1) {
          offers = offers.sort(
            (a: PaymentOfferRule, b: PaymentOfferRule) => b?.priority - a?.priority
          );
        }

        if (offers?.length) {
          const keys = offers.map(offer => offer?.ruleKey);
          offerData = doCheckOffers(false, PAYMENT_MODES.UPI, cartRules, paymentInfo, keys);
          if (offerData?.hasOffers && offerData?.finalOrderAmount) {
            offerMessages = getOfferMessages(offerData, theme, () =>
              toggleOfferBottomSheet(offerData)
            );

            revisedBtnText = getStringFromId(
              VERNACULAR_STRING_IDS.DYNAMIC_PAY_WITH_STRIKED_AMOUNT,
              `Pay ₹${formatNumber(offerData?.finalOrderAmount)} &nbsp; <del> ₹${formatNumber(grandTotal)}</del>`,
              {
                oldAmount: grandTotal,
                newAmount: offerData?.finalOrderAmount || "",
              }
            );
          }
        }
      }
      /**
       * if we have a payment_alert status is 1 (normal) and 2 (warning) in few upi methods then we will show
       * the warning message from customer_vpa_list.
       * if warning message not present then show then show message from alert config.
       * if in alert config, bank name list is empty then will show the message on all saved upi's.
       * if in alert config, any bank name present then will show the message on particular upi.
       */
       if (
        upiPaymentAlertInfo?.mode === PAYMENT_MODES.UPI &&
        (upiPaymentAlertInfo?.status === ALERT_PAYMENT_STATUS.NORMAL ||
          (upiPaymentAlertInfo?.status === ALERT_PAYMENT_STATUS.WARNING))
      ) {
        warningMessage = "";
        if (vpaInfo?.warningMessage) {
          warningMessage = vpaInfo?.warningMessage;
        } else if (allUpisHavingIssues() || (upiPaymentAlertInfo?.bankName?.length && upiPaymentAlertInfo?.bankName?.includes(vpaInfo?.title))) {
          warningMessage = alertConfig?.alertMessage;
        } 
      }
      if (
        upiPaymentAlertInfo?.mode === PAYMENT_MODES.UPI &&
        (upiPaymentAlertInfo?.status === ALERT_PAYMENT_STATUS.DISABLE ||
          upiPaymentAlertInfo?.status === ALERT_PAYMENT_STATUS.HIDE)
      ) {
        warningMessage = PAYMENT_ALERT_MESSAGE.PAYMENT_METHOD_EXPERIENCING_ISSUES;
      }
    }
    const packageName = upiMapping?.find((upi: any) => upi.title === vpaDetails?.title)?.package;
    const upiDetails = {...vpaDetails, ...{ enableIntent, packageName }}
    saveUpiConfig.push({
      upiId: "Last",
      alert: {
        leadingIcon: getIcons(platform, ICONS_NAMES.WARN_ICON),
        warn: true,
        text: warningMessage,
      },
      title: enableIntent ? title : (vpaDetails.title || title),
      subTitle: enableIntent ? vpaDetails.title : vpa,
      vpa: vpa,
      payNowText,
      revisedPayNowText: revisedBtnText,
      leadingIcon: vpaDetails.icon,
      doPayment: () => handleSavedUpiSubmit(vpa, offerData, upiDetails),
      offerMessages: offerMessages,
      pymentMethod: PAYMENT_MODES.UPI,
      offerDetailConfig,
      isDisabled: !isPaymentEnabled,
      isHidden: !isPaymentMethodVisible,
      priority: !isPaymentEnabled ? 1 : 0,
      theme,
    });
  } else if (Array.isArray(vpaHandleList) && vpaHandleList.length) {
    const lastvpa = getVpaDetails(lastUpiPayment, upiMapping);
    vpaHandleList.map((value, key) => {
      const upiId = key;
      const vpa = value.vpa || '';
      const enableIntent = value.enableIntent; // it is for upi intent enable or not.


      /**
       * if we have a payment_alert status is 1 (normal) and 2 (warning) in few upi methods then we will show
       * the warning message from customer_vpa_list.
       * if warning message not present then show then show message from alert config.
       * if in alert config, bank name list is empty then will show the message on all saved upi's.
       * if in alert config, any bank name present then will show the message on particular upi.
       */
      if (
        upiPaymentAlertInfo?.mode === PAYMENT_MODES.UPI &&
        (upiPaymentAlertInfo?.status === ALERT_PAYMENT_STATUS.NORMAL ||
          (upiPaymentAlertInfo?.status === ALERT_PAYMENT_STATUS.WARNING))
      ) {
        warningMessage = "";
        if (value.warningMessage) {
          warningMessage = value.warningMessage;
        } else if (allUpisHavingIssues() || (upiPaymentAlertInfo?.bankName?.length && upiPaymentAlertInfo?.bankName?.includes(value?.title))) {
          warningMessage = alertConfig?.alertMessage;
        } 
      }
      if (
        upiPaymentAlertInfo?.mode === PAYMENT_MODES.UPI &&
        (upiPaymentAlertInfo?.status === ALERT_PAYMENT_STATUS.DISABLE ||
          upiPaymentAlertInfo?.status === ALERT_PAYMENT_STATUS.HIDE)
      ) {
        warningMessage = PAYMENT_ALERT_MESSAGE.PAYMENT_METHOD_EXPERIENCING_ISSUES;
      }

      const iconIntentUrl = value.iconIntentUrl;
      const vpaDetails = getVpaDetails(vpa, upiMapping);
      const offerKeys = value.offerKeys || [];

      // not showing same upi that was shown in last payment method
      /**
       * Incase of webview, user have upi_intent in last payment info & application is present in user's device 
       * then we need to remove the same psp from the list.
       * Ex:- If user has 2 PhonePe collect, 2 Google Pay collect in saved method, 
       * then pay via Google Pay intent,
       * then Google Pay intent show as a last payment info in saved method, 
       * then user won't be able to see the 2 Google Pay collect. only shows Google Pay Intent as first saved method.
       */
      if (
        vpaDetails.vpa == lastvpa?.vpa ||
        (isApp &&
          paymentInfo?.lastPaymentInfo?.packageName === vpaDetails?.packageName &&
          installedPSP.includes(upiIntentDetails?.title))
      ) 
        return;
      let offerMessages: IOfferMessage[] = [];
      let revisedBtnText = strikedPaymentText;
      let offerData = {} as OfferDataInterface;
      let offers: any[] = [];
      if (offerKeys?.length) {
        offerKeys.forEach((offerKey: string) => {
          let offer = cartRules.paymentRules.filter(
            (rule: PaymentOfferRule) => rule.ruleKey === offerKey
          );
          offers.push(offer);
          offers = offers.flat();
        });
        if (offers?.length > 1) {
          offers = offers.sort(
            (a: PaymentOfferRule, b: PaymentOfferRule) => b?.priority - a?.priority
          );
        }

        if (offers?.length) {
          const keys = offers.map(offer => offer?.ruleKey);
          offerData = doCheckOffers(false, PAYMENT_MODES.UPI, cartRules, paymentInfo, keys);
          if (offerData?.hasOffers && offerData?.finalOrderAmount) {
            offerMessages = getOfferMessages(offerData, theme, () =>
              toggleOfferBottomSheet(offerData)
            );

            revisedBtnText = getStringFromId(
              VERNACULAR_STRING_IDS.DYNAMIC_PAY_WITH_STRIKED_AMOUNT,
              `Pay ₹${formatNumber(offerData?.finalOrderAmount)} &nbsp; <del> ₹${formatNumber(grandTotal)}</del>`,
              {
                oldAmount: grandTotal,
                newAmount: offerData?.finalOrderAmount || "",
              }
            );
          }
        }
      }
      let vpaTitle = value.title || vpaDetails.title || title;
      let vpaSubTitle = vpaDetails.vpa.length < 33 ? vpaDetails.vpa : vpaDetails.vpa.substring(0, 33) + "...";
      if (enableIntent) {
        vpaTitle = title;
        vpaSubTitle = vpaDetails.title
      }

      saveUpiConfig.push({
        upiId,
        title: vpaTitle,
        subTitle: vpaSubTitle,
        vpa: vpaDetails.vpa,
        alert: {
          leadingIcon: getIcons(platform, ICONS_NAMES.WARN_ICON),
          warn: true,
          text: warningMessage,
        },
        payNowText,
        revisedPayNowText: revisedBtnText,
        leadingIcon: iconIntentUrl,
        doPayment: () => handleSavedUpiSubmit(vpa, offerData, value),
        offerMessages: offerMessages,
        pymentMethod: PAYMENT_MODES.UPI,
        offerDetailConfig,
        isDisabled: !isPaymentEnabled,
        isHidden: !isPaymentMethodVisible,
        priority: upiPaymentAlertInfo?.bankName?.includes('UPI') && lessPriority ? 1 : 0,
        theme,
        buttonType: BUTTON_TYPE.MEDIUM,
      });
    });
  }
  
  return saveUpiConfig;
};